import { request as getBonuses, error as onBonusError, finish as onBonusFinish } from './reducers/query-bonuses';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    BONUSES_REQUEST: getBonuses,
    BONUSES_ERROR: onBonusError,
    BONUSES_FINISH: onBonusFinish,
});
